import { render, staticRenderFns } from "./SmartPlayerScreen.vue?vue&type=template&id=12cc56fe"
import script from "./SmartPlayerScreen.vue?vue&type=script&lang=js"
export * from "./SmartPlayerScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports